/* Presentation only. Shopify retains all purchase and cart decisions. */
(() => {
  if (customElements.get('stock-status-preview')) return;
  customElements.define('stock-status-preview', class extends HTMLElement {
    connectedCallback() {
      this.component = this.closest('[data-section-type]');
      this.sync = event => {
        const id = String(event.detail?.variant?.id || '');
        const rows = [...this.querySelectorAll('[data-stock-variant]')];
        const row = rows.find(item => item.dataset.stockVariant === id);
        const summary = this.querySelector('[data-stock-summary]');
        if (!row || !summary) return;
        rows.forEach(item => {
          item.toggleAttribute('data-selected', item === row);
          if (row.hasAttribute('data-stock-color')) {
            item.hidden = item.dataset.stockColor !== row.dataset.stockColor;
          }
        });
        for (const channel of ['web', 'store']) {
          const source = row.querySelector(`[data-stock-${channel}]`);
          const target = summary.querySelector(`[data-stock-${channel}]`);
          target.dataset.state = source.dataset.state;
          target.querySelector('[data-stock-text]').textContent = source.textContent;
        }
        summary.querySelector('[data-stock-selected]').textContent = `${row.querySelector('th').textContent}: `;
        const delivery = row.querySelector('[data-stock-estimate]').textContent.trim();
        const target = summary.querySelector('[data-stock-summary-delivery]');
        target.hidden = !delivery;
        target.textContent = delivery ? `${this.dataset.deliveryPrefix} ${delivery}` : '';
      };
      document.addEventListener('theme:variant:change', this.sync);
      this.controllers = [];
      this.querySelectorAll('[data-stock-variant]').forEach(async row => {
        const controller = new AbortController();
        this.controllers.push(controller);
        const timer = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}variants/${row.dataset.stockVariant}/?section_id=store-availability`, {signal: controller.signal});
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const location = html.querySelector('[data-stock-location="106200072540"]');
          if (!location || !this.isConnected) return;
          const state = location.dataset.stockAvailable === 'true' ? 'in' : 'out';
          const target = row.querySelector('[data-stock-store]');
          target.dataset.state = state;
          target.querySelector('[data-stock-text]').textContent = state === 'in' ? this.dataset.stockIn : this.dataset.stockOut;
          const selected = this.closest('form')?.querySelector('[name="id"]')?.value;
          if (selected) this.sync({detail: {variant: {id: selected}}});
        } catch { /* Keep unavailable pickup data explicitly unknown. */ }
        finally { clearTimeout(timer); }
      });
    }
    disconnectedCallback() {
      document.removeEventListener('theme:variant:change', this.sync);
      this.controllers?.forEach(controller => controller.abort());
    }
  });
})();
